import { isEqual } from 'radash';
import { useRef } from 'react';

export function useStableComboboxKey(fieldPath: string, value: unknown) {
    const lastKnownValueRef = useRef<unknown>(value);
    const generationRef = useRef(0);

    if (!isEqual(value, lastKnownValueRef.current)) {
        generationRef.current += 1;
        lastKnownValueRef.current = value;
    }

    const markUserChange = (nextValue: unknown) => {
        lastKnownValueRef.current = nextValue;
    };

    return {
        comboboxKey: `${fieldPath}-${generationRef.current}`,
        markUserChange,
    };
}
